<template>
    <div>
        <el-table
            ref="multipleTable"
            :data="cartList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
            type="selection"
            width="55">
            </el-table-column>
            <el-table-column
            label="商品标题"
            width="400">
            <template slot-scope="scope">{{ scope.row.title }}</template>
            </el-table-column>
            <el-table-column
            label="图片"
            width="200">
            <template  slot-scope="scope">
                <img :src="require(`@/assets/product/${scope.row.img}`)" class="cartImg">
            </template>
            </el-table-column>
            <el-table-column
            prop="productPrice"
            label="单价"
            width="100">
            </el-table-column>
            <el-table-column
            prop="num"
            label="数量"
            width="100"
            show-overflow-tooltip>
            </el-table-column>
            <el-table-column
            label="操作"
            width="100"
            show-overflow-tooltip>
               <template v-slot="scope">
                  <el-button type="primary" icon="el-icon-delete" @click="deleteCart(scope.row.id)"></el-button>
               </template>
            </el-table-column>
        </el-table>
        <div class="foot">
            <span>总计:</span><span>{{ totalPrice }}￥</span>
            <el-button type="primary" @click="toPay">下单</el-button>
        </div>
       
    </div>
</template>
<script>
export default {
    name: 'cart',
    data(){
      return {
        cartList:[],
        multipleSelection: [],
        totalPrice:0,
      }
    },
    components: {
      
    },
     methods:{
      deleteCart(id){
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http.get("/product/deleteCart/"+id).then(res=>{
                if(res.data.res==true){
                  this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getCartList();
                }else{
                  this.$message({
                    type: 'error',
                    message: '删除失败!'
                  })
                }
            })
           
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
        },
      handleSelectionChange(val) {
        this.multipleSelection=[];
        this.totalPrice=0;
        this.multipleSelection = val;
        this.multipleSelection.forEach(item=>{
          this.totalPrice= this.totalPrice+(item.productPrice*item.num);
        })
      },
      toPay(){
        if(this.multipleSelection.length==0){
          this.$message({
            showClose: true,
            message: '请选择商品',
          })
        }else{
          this.$message({
                message: '下单成功',
                type: 'success'
                });
        }
      },
      getCartList(){
        this.$http.get('/product/getCartList').then(res=>{
              this.cartList=res.data.res
          })
      }
      },
      mounted(){
        this.getCartList();
      }
    }
</script>
<style scoped>
.cartImg{
    width: 200px;
    height: 200px;
}
.foot{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
  .foot span{
    margin-right: 10px;
  }
   
</style>